import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewAllBoardsNonFinal: {
		id: 'navigation-apps-sidebar-nav4-jsw-project-menu.jsw-expandable-project.async-content.view-all-boards-non-final',
		defaultMessage: 'View all boards',
		description: 'Link to view all boards',
	},
	starred: {
		id: 'navigation-apps-sidebar-nav4-jsw-project-menu.jsw-expandable-project.async-content.starred',
		defaultMessage: 'Starred',
		description: 'Message for starred heading in the project boards menu items',
	},
	recent: {
		id: 'navigation-apps-sidebar-nav4-jsw-project-menu.jsw-expandable-project.async-content.recent',
		defaultMessage: 'Recent',
		description: 'Message for recent heading in the project boards menu items',
	},
	viewAllStarred: {
		id: 'navigation-apps-sidebar-nav4-jsw-project-menu.jsw-expandable-project.async-content.view-all-starred',
		defaultMessage: 'View all starred',
		description: 'Message for view all starred link in the starred projects section',
	},
});
